import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// import apolloClient from 'core/api/apollo/apollo';
import history from './history';

const middleware = applyMiddleware(
	thunk,
	routerMiddleware(history),
	/* apolloClient.middleware() */
);

export default middleware;



// WEBPACK FOOTER //
// ./src/core/store/middleware.prod.ts